import { render, staticRenderFns } from "./SfGroupedProductItem.vue?vue&type=template&id=6d28c983&"
import script from "./SfGroupedProductItem.vue?vue&type=script&lang=js&"
export * from "./SfGroupedProductItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports